import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getAllPermissionsKey } from "src/api/client-api/permissions/useGetAllPermissions.ts";

type PermissionCreate = {
    isNew: boolean;
    permission: PermissionPayload;
};

export const useCreatePermission = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (options: PermissionCreate) => {
            const { permission, isNew } = options;

            return isNew ?
                    await loggedInApiCall.post("/api/permissions", permission)
                :   await loggedInApiCall.put(`/api/permissions/${permission.id}`, permission);
        },
        onSuccess: () => queryClient.invalidateQueries([getAllPermissionsKey]),
    });
};

export type PermissionPayload = {
    id?: number;
    identifier: string;
    slug: string;
    object: string;
    extra: string | null;
};
